import _castArray from 'lodash/castArray';
import _get from 'lodash/get';
import { toCamelCase } from '@/utilities';
import { EmailAttachment, Base } from '@/models';

export class EmailLog extends Base {

  public templateid: string;
  public maintenancejobid?: string;
  public fromaddress: string;
  public toaddresses: string[];
  public ccaddresses: string[];
  public bccaddresses: string[];
  public attachments: EmailAttachment[];
  public subject: string;
  public message: string;

  /**
   * Constructor
   */
  public constructor(data?: Partial<EmailLog>) {
    super(data);
    data = toCamelCase(data);

    this.templateid = _get(data, 'templateid', '');
    this.maintenancejobid = _get(data, 'maintenancejobid', '');
    this.fromaddress = _get(data, 'fromaddress', '');
    this.toaddresses = _castArray(_get(data, 'toaddresses', []));
    this.ccaddresses = _castArray(_get(data, 'ccaddresses', []));
    this.bccaddresses = _castArray(_get(data, 'bccaddresses', []));
    this.attachments = _castArray(_get(data, 'attachments', [])).map((x: any) => new EmailAttachment(x));
    this.subject = _get(data, 'subject', '');
    this.message = _get(data, 'message', '');
  }
}
